<template>
    <b-navbar toggleable="md">
        <div class="mx-auto d-sm-flex d-block flex-sm-nowrap">
            <b-navbar-toggle target="nav_collapse_funeral"></b-navbar-toggle>
            <b-collapse is-nav id="nav_collapse_funeral" class="text-center collapse navbar-collapse">
                <b-navbar-nav>

                    <b-nav-item :to="'/my-funeral/burial'">
                        {{ $t('menu.items.funeral.burial') }}
                    </b-nav-item>
                    <b-nav-item :to="'/my-funeral/ceremony'">
                        {{ $t('menu.items.funeral.ceremony') }}
                    </b-nav-item>
                    <b-nav-item :to="'/my-funeral/guestlist'">
                        {{ $t('menu.items.funeral.guestlist') }}
                    </b-nav-item>
                    <b-nav-item :to="'/my-funeral/speeches'">
                        {{ $t('menu.items.funeral.speeches') }}
                    </b-nav-item>

                </b-navbar-nav>
            </b-collapse>
        </div>
    </b-navbar>
</template>

<script>

    export default {
        name: 'FuneralMenu'
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/custom/vars';

    #nav_collapse_funeral > ul > li > a {
        color: white;
        &:hover {
            text-decoration: none;
            color: $omyfu-hover;
        }
    }

    #nav_collapse_funeral > ul > li > a.active {
        color: $omyfu-yellow;
    }

    .navbar {
        background-color: $omyfu-red;
        padding: 0px;
    }

</style>



// WEBPACK FOOTER //
// src/components/funeral/FuneralMenuComponent.vue